import addDotsToPrice from "../price-format";
import baseUrl from "../../url/baseUrl";
import { useEffect, useState } from "react";

// component thông tin cá nhân của người trong hóa đơn
const BillInfo = ({ orderId, userId, name, phone, address, total }) => {
  const [success, setSuccess] = useState(false);
  const [delivery, setDelivery] = useState("");

  useEffect(() => {
    const getDelivery = async () => {
      try {
        const response = await fetch(`${baseUrl}/orders/${orderId}`, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });

        if (response.status === 404) {
          throw new Error("No found order information");
        }

        if (response.status !== 200) {
          throw new Error("Not yet login or server error");
        }

        const data = await response.json();

        setDelivery(data.delivery);
      } catch (err) {
        console.log(err);
      }
    };
    getDelivery();
  }, [orderId, success]);

  const handleSubmit = async () => {
    try {
      const response = await fetch(`${baseUrl}/status/${orderId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify({ delivery: "Giao thành công" }),
        credentials: "same-origin",
        mode: "cors",
      });

      if (response.status !== 200) {
        throw new Error("Something went wrong with server");
      }
      setSuccess((prevState) => !prevState);
      alert("Chúc mừng bạn đã nhận hàng!");
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <section>
      <h2 className="bill_info">INFORMATION ORDER</h2>
      <p className="bill_info">User ID: {userId}</p>
      <p className="bill_info">Full Name: {name}</p>
      <p className="bill_info">Phone: {phone}</p>
      <p className="bill_info">Address: {address}</p>
      <p className="bill_info">Total: {addDotsToPrice(total)}</p>
      <p className="bill_info">
        Tình trạng đơn hàng: <span className="text-danger">{delivery}</span>
      </p>
      <div className="d-flex mb-3">
        <div className="me-3">
          <p className="me-3 mb-0">Xác nhận của khách hàng: </p>
          <p className="text-primary">
            (Bấm vào nút bên để xác nhận bạn đã nhận được hàng){" "}
          </p>
        </div>

        <button onClick={handleSubmit} className="btn btn-success">
          Đã nhận được hàng
        </button>
      </div>
    </section>
  );
};

export default BillInfo;
